/* ===================================================
   JF Meta Landing — custom JS
   Loaded only on product.meta-landing template
   - Countdown timer
   - Savings badge variant-change updates
   =================================================== */
(function () {
  'use strict';

  /* ===== Countdown ===== */
  function initCountdown(el) {
    // The jf-countdown section now self-initializes inline. Skip if already done
    // (either by this script or the section) to avoid a double interval.
    if (el.hasAttribute('data-jf-cd-init')) return;
    el.setAttribute('data-jf-cd-init', '1');
    var mode = el.dataset.mode || 'end_of_day';
    var fixedEnd = el.dataset.fixedEnd;
    var onZero = el.dataset.onZero || 'hide';
    var rollingDays = parseInt(el.dataset.rollingDays || '3', 10) || 3;
    var daysEl = el.querySelector('[data-jf-countdown-days]');
    var hoursEl = el.querySelector('[data-jf-countdown-hours]');
    var minutesEl = el.querySelector('[data-jf-countdown-minutes]');
    var secondsEl = el.querySelector('[data-jf-countdown-seconds]');
    var timerId = null;

    function getEndTime() {
      var now = new Date();
      if (mode === 'fixed' && fixedEnd) {
        var parts = fixedEnd.replace('T', ' ').split(/[- :]/);
        if (parts.length >= 6) {
          return new Date(
            parseInt(parts[0], 10),
            parseInt(parts[1], 10) - 1,
            parseInt(parts[2], 10),
            parseInt(parts[3], 10),
            parseInt(parts[4], 10),
            parseInt(parts[5], 10)
          );
        }
        return new Date(fixedEnd);
      }
      if (mode === 'end_of_hour') {
        var endHr = new Date(now);
        endHr.setMinutes(60, 0, 0);
        return endHr;
      }
      if (mode === 'rolling') {
        // Evergreen per-visitor: fresh N-day countdown, loops when it hits 0.
        var cycleMs = rollingDays * 86400000;
        var key = 'jfCdEnd_' + rollingDays;
        var t = now.getTime();
        var stored = 0;
        try { stored = parseInt(localStorage.getItem(key) || '0', 10) || 0; } catch (e) {}
        if (!stored || stored <= t) {
          stored = t + cycleMs;
          try { localStorage.setItem(key, String(stored)); } catch (e) {}
        }
        return new Date(stored);
      }
      var end = new Date(now);
      end.setHours(23, 59, 59, 999);
      return end;
    }

    function pad(n) {
      return String(n).padStart(2, '0');
    }

    function showExpired() {
      if (timerId) clearInterval(timerId);
      if (onZero === 'hide') {
        el.classList.add('is-expired-hidden');
      } else {
        el.classList.add('is-expired-message');
        var msg = el.querySelector('.jf-countdown__expired');
        if (!msg) {
          msg = document.createElement('div');
          msg.className = 'jf-countdown__expired';
          msg.textContent = el.dataset.expiredText || '';
          el.appendChild(msg);
        }
      }
    }

    function tick() {
      var diff = Math.floor((getEndTime() - new Date()) / 1000);
      if (diff <= 0) {
        showExpired();
        return;
      }
      var days = 0;
      if (daysEl) {
        days = Math.floor(diff / 86400);
        diff -= days * 86400;
      }
      var hours = Math.floor(diff / 3600);
      diff -= hours * 3600;
      var minutes = Math.floor(diff / 60);
      var seconds = diff - minutes * 60;
      if (daysEl) daysEl.textContent = pad(days);
      if (hoursEl) hoursEl.textContent = pad(hours);
      if (minutesEl) minutesEl.textContent = pad(minutes);
      if (secondsEl) secondsEl.textContent = pad(seconds);
    }

    tick();
    timerId = setInterval(tick, 1000);
  }

  /* ===== Savings badge: update on variant change ===== */
  function updateSavingsBadges() {
    var badges = document.querySelectorAll('[data-jf-savings-badge]');
    if (!badges.length) return;
    var priceEl = document.querySelector('[data-ed-product-price][data-price]');
    var compareEl = document.querySelector('[data-compare-price]');
    if (!priceEl) return;

    var price = parseInt(priceEl.dataset.price || '0', 10);
    var compare = 0;
    if (compareEl) {
      if (compareEl.dataset.price) {
        compare = parseInt(compareEl.dataset.price, 10) || 0;
      } else {
        compare = parseInt((compareEl.textContent || '').replace(/[^\d]/g, ''), 10) || 0;
      }
    }

    var pct = compare > price ? Math.round((compare - price) * 100 / compare) : 0;
    badges.forEach(function (badge) {
      var pctEl = badge.querySelector('[data-jf-savings-pct]');
      if (pctEl) pctEl.textContent = pct;
      badge.style.display = compare > price ? '' : 'none';
    });
  }

  function init() {
    document.querySelectorAll('[data-jf-countdown]').forEach(initCountdown);
    document.addEventListener('variant:change', function () {
      setTimeout(updateSavingsBadges, 0);
    });
    setTimeout(updateSavingsBadges, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
